{
    "grid-border-color":"#e9e9e9",
    "grid-header-bg-color": "#0a6fc2",
    "grid-header-font-color": "#ffffff",
    "grid-cell-text-align":"center",
    "grid-row-hover-bg-color": "#79bff8",
    "grid-row-active": "#4daaf6",
    "grid-row-alternate": "#e7f3fe",
    "grid-footer-bg-color": "#2196f3",
    "grid-footer-font-color": "#ffffff",
    "grid-cell-font-color": "#303030",
    "grid-checkbox-bg-color": "#2196f3",
    "tile-border-color":"#e9e9e9",
    "tile-bg-color": "#0a6fc2",
    "tile-font-color": "#ffffff",
    "tile-hover-bg-color": "#2597f4",
    "header-bg-color": "#0a6fc2",
    "header-ico-active-color": "#2597f4",
    "title-font-color": "#0a6fc2",
    "login-ico-color": "#0a6fc2",
    "button-primary-bg-color": "#0a6fc2",
    "button-primary-hover-bg-color": "#2597f4",
    "button-secondary-bg-color": "#009999",
    "button-secondary-hover-bg-color": "#009999",
    "button-secondary-font-color": "#ffffff",
    "object-ico-color": "#0a6fc2",
    "object-ico-active-color": "#2597f4"
}